import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BrandingContext = createContext(null);

export function BrandingProvider({ children }) {
  const [logo, setLogo] = useState(null);

  const refresh = useCallback(() => {
    return api
      .get("/settings/branding")
      .then(({ data }) => setLogo(data.logo || null))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <BrandingContext.Provider value={{ logo, refresh }}>{children}</BrandingContext.Provider>;
}

export const useBranding = () => useContext(BrandingContext) || { logo: null, refresh: () => {} };
